import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'app-card-layout-content',
  templateUrl: './card-layout-content.component.html',
  styleUrls: ['./card-layout-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardLayoutContentComponent {
  @Input() showProgressBar = false

  constructor() {}
}
